import React from "react";
import useMayaMiniAppLoggedOut from "../mayaminiapp/useMayaMiniAppLoggedOut";
import useGlifeLoggedOut from "../glife/useGlifeLoggedOut";
import useGlifeDisclaimerRoute from "../glife/useGlifeDisclaimerRoute";
import useGlifeCheckContextAndMode from "../glife/useGlifeCheckContextAndMode";
import useGlifeLinkEvents from "../glife/useGlifeLinkEvents";

const RoutingUtils: React.FC = () => {
  useMayaMiniAppLoggedOut();
  useGlifeLoggedOut();
  useGlifeDisclaimerRoute();
  useGlifeCheckContextAndMode();
  useGlifeLinkEvents();
  return null;
};

export default RoutingUtils;
